import { useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/NewConfiguration.css";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
const NewConfigurationMessageBox = ({showNewConfiguration,showNewConfigurationMessageBox,setShowNewConfigurationMessageBox,errorTitle,errorMessage}) =>{
    if(!showNewConfiguration || !showNewConfigurationMessageBox) return null;
    return(
        <div className="new-device-configuration-message-box-container">
            <div className="new-device-configuration-message-box-title-container">
                <p>{errorTitle}</p>
                <p
                    style={{cursor:'pointer'}}
                    onClick={() => setShowNewConfigurationMessageBox(false)}>&#10006;</p>
            </div>
            <div className="new-device-configuration-message-box-message-container">
                <p>{errorMessage}</p>
            </div>
            <div className="new-device-configuration-message-box-buttons-container">
                <button onClick={() => setShowNewConfigurationMessageBox(false)}>Ok</button>
            </div>
        </div>
    );
};
const NewConfiguration = ({accessToken,showNewConfiguration,setShowNewConfiguration}) =>{
    const [deviceDetailsName,setDeviceDetailsName] = useState('');
    const [deviceDetailsType,setDeviceDetailsType] = useState('');
    const [rows, setRows] = useState([]);
    const [showNewConfigurationMessageBox,setShowNewConfigurationMessageBox] = useState(false);
    const [configurationCreationSuccessful,setConfigurationSuccessful] = useState(false);
    const [errorTitle,setErrorTitle] = useState('Error');
    const [errorMessage,setErrorMessage] = useState('An error occurred');
    const addNewRow = () =>{
        setRows([...rows,{parameter:'',defaultValue: ''}]);
    };
    const showMessageBox = (title,message) =>{
        setErrorTitle(title);
        setErrorMessage(message);
        setShowNewConfigurationMessageBox(true);
    };
    const saveNewDeviceConfiguration = async() =>{
        try{
            let newDeviceConfiguration = {
                name:deviceDetailsName,
                attributes:deviceDetailsType,
                details: rows.map(row =>({
                    parameter: row.parameter,
                    defaultValue: row.defaultValue
                }))
            };
            const url = `${thingsBoardMicroserviceUrl}/tenants/devices/configurations/templates/create`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(newDeviceConfiguration)
            });
            if(!response.ok){
                if(response.status === 409) showMessageBox('Configuration not created','A configuration with this name already exists. Please choose a different name or update the existing configuration.');
                else throw new Error('Network response was not ok');
            }
            else {
                showMessageBox('Configuration created','The configuration has been created successfully.');
                setConfigurationSuccessful(true);
            }
        }
        catch(error){
            console.error(`New device configuration not created: ${error}`);
            showMessageBox('Configuration not created','An error occurred when creating the new configuration');
        }
    };
    const clearEntries = () =>{
        setDeviceDetailsName('');
        setDeviceDetailsType('');
        setRows([]);
        setShowNewConfigurationMessageBox(false);
        setConfigurationSuccessful(false);
        setErrorTitle('Error');
        setErrorMessage('An error occurred');
    };
    useEffect(() =>{
        if(showNewConfigurationMessageBox || !configurationCreationSuccessful) return;
        clearEntries();
        setShowNewConfiguration(false);
    },[showNewConfigurationMessageBox,configurationCreationSuccessful]);
    if(!showNewConfiguration) return null;
    return(
        <div className="new-device-configuration-container">
            <div className="new-device-configuration-header">
                <h3>New device configuration</h3>
                <p
                    onClick={() => {
                        if(showNewConfigurationMessageBox) return;
                        setShowNewConfiguration(false);
                    }}>&#10006;</p>
            </div>
            <div className="new-device-configuration-body">
                <div className="new-device-configuration-device-details-container">
                    <h5>Device details</h5>
                    <div className="new-device-configuration-title-input-container">
                        <p>Name</p>
                        <input
                            type="text"
                            disabled={showNewConfigurationMessageBox}
                            value={deviceDetailsName}
                            onChange={(e) => setDeviceDetailsName(e.target.value)}/>
                    </div>
                    <div className="new-device-configuration-type-input-container">
                        <p>Type</p>
                        <select
                            disabled={showNewConfigurationMessageBox}
                            value={deviceDetailsType}
                            onChange={(e)=> setDeviceDetailsType(e.target.value)}>
                            <option disabled value=''>Please select</option>
                            <option value='server'>Server attributes</option>
                            <option value='shared'>Shared attributes</option>
                            <option value='client'>Client attributes</option>
                        </select>
                    </div>
                </div>
                <div className="new-configuration-details-device-parameters">
                    <h5 className="new-configuration-details-table-header">Device parameters</h5>
                    <div className="new-configuration-details-table-container">
                        <table className="new-configuration-details-table">
                            <thead>
                                <tr id="header-row">
                                    <th className="new-configuration-details-table-parameter-th">
                                        Parameter
                                    </th>
                                    <th>
                                        Default value
                                    </th>
                                    <th>
                                        <button className="add-new-configuration-button" onClick={() => {
                                            if(showNewConfigurationMessageBox) return;
                                            addNewRow();
                                            }}><img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row,index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                disabled={showNewConfigurationMessageBox}
                                                type="text"
                                                value={row.parameter}
                                                onChange={(e) => {
                                                    const newRows = [...rows];
                                                    newRows[index].parameter = e.target.value;
                                                    setRows(newRows);
                                                }}
                                                placeholder="Enter parameter"/>
                                        </td>
                                        <td>
                                            <input
                                                disabled={showNewConfigurationMessageBox}
                                                type="text"
                                                value={row.defaultValue}
                                                onChange={(e) => {
                                                    const newRows = [...rows];
                                                    newRows[index].defaultValue = e.target.value;
                                                    setRows(newRows);
                                                }}
                                                placeholder="Enter default value"
                                            />
                                        </td>
                                        <td>
                                            <button 
                                                onClick={() =>{
                                                    if(showNewConfigurationMessageBox) return;
                                                    const newRows = rows.filter((_,i) => i !== index);
                                                    setRows(newRows);
                                                }}>
                                                <img src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} alt="Add" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="new-device-configuration-buttons-container">
                <button onClick={async() =>{
                    if(showNewConfigurationMessageBox) return;
                    if(deviceDetailsName.length === 0) showMessageBox('Missing entry','Please enter the name of the configuration');
                    else if(deviceDetailsType === '') showMessageBox('Missing entry','Please select the type of the configuration');
                    else if (rows.length === 0) showMessageBox('Parameters required','Please add at least one parameter');
                    else if (rows.some(row => row.parameter === '')) showMessageBox('Missing parameter','One or more parameter fields are empty. Please fill them in.');
                    else if (rows.some(row => row.defaultValue === '')) showMessageBox('Missing default value','One or more default value fields are empty. Please fill them in.');
                    else saveNewDeviceConfiguration();
                }}>Create</button>
                <button
                    onClick={() => {
                        if(showNewConfigurationMessageBox) return;
                        setShowNewConfiguration(false);
                    }}>Cancel</button>
            </div>
            <NewConfigurationMessageBox
                showNewConfiguration={showNewConfiguration}
                showNewConfigurationMessageBox={showNewConfigurationMessageBox}
                setShowNewConfigurationMessageBox={setShowNewConfigurationMessageBox}
                errorTitle={errorTitle}
                errorMessage={errorMessage}
            />
        </div>
    );
};
export default NewConfiguration;